import { isString, isUuid } from '@pogokid/util/lodash'
import {
  CREATE_CONTACT_ID,
  ExistingContactRelationshipSchema,
  NewContactRelationshipSchema,
} from './types'

export function isNewContactRelationship(
  schema: unknown
): schema is NewContactRelationshipSchema {
  // contact_id is optional here: a brand-new contact has no id and is
  // identified by name + relationship, so it must not be a required field.
  if (!schema || typeof schema !== 'object') return false
  const contact_id =
    'contact_id' in schema ? schema.contact_id : undefined
  return contact_id === CREATE_CONTACT_ID
    ? true
    : [
        !isUuid(contact_id),
        isString(
          'relationship' in schema
            ? schema.relationship
            : undefined
        ),
        isString('name' in schema ? schema.name : undefined),
      ].every(Boolean)
}

export function isExistingContactRelationship(
  schema: unknown
): schema is ExistingContactRelationshipSchema {
  return (
    !!schema &&
    typeof schema === 'object' &&
    'relationship' in schema &&
    'contact_id' in schema &&
    [
      isString(schema.relationship),
      isString(schema.contact_id),
      schema.contact_id !== CREATE_CONTACT_ID,
    ].every(Boolean)
  )
}
